const items = [
  "Tree Removal",
  "Elevation & Trimming",
  "Deadwooding",
  "Landscaping",
  "Mulching",
  "Gutter Cleaning",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div data-testid="marquee" className="bg-pine border-y border-white/10 py-6 overflow-hidden">
      <div className="marquee-track">
        {row.map((t, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="font-display font-extrabold text-bone text-2xl md:text-4xl uppercase tracking-tight px-8">
              {t}
            </span>
            <span className="text-terra text-2xl md:text-4xl">✳</span>
          </span>
        ))}
      </div>
    </div>
  );
};
